<template>
  <div class="Timeline">
    <div class="box" v-for="(e, index) in events">
      <process_line v-if="index!=0"></process_line>
      <time_event :event="e.event" :time="e.time" :color="color[index]"></time_event>
    </div>
  </div>
</template>

<script>
 import TimeEvent from '@/components/frontpage/TimeEvent.vue';
 import Processline from '@/components/frontpage/Processline.vue';
 export default {
   name: 'Timeline',
   props: ['process'],
   computed: {
     events () {
       return this.process
     },
     color () {
       return [
         '#7ade61',
         '#feb83d',
         '#00c5b8',
         '#e65e63',
         '#587792',
       ]
     }
   },
   components: {
     process_line: Processline,
     time_event: TimeEvent
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .Timeline{
   display: flex;
 }
 .box{
   display: flex;
 }
</style>
